<template>
  <div class="flex flex-col items-center justify-center h-full">
    <span class="font-bold text-3xl text-eco-red"> Upps :/ </span>
    <span class="text-sm mt-2"> Something went wrong. Please try again later. </span>
    <button
      @click="refresh"
      class="w-32 h-8 bg-eco-darkblue p-6 rounded-lg flex items-center justify-center mt-8"
    >
      <span class="text-white font-bold text-sm"> Refresh {{ leftCountClaim }}</span>
    </button>
  </div>
</template>
<script setup>
const leftCountClaim = 1
const refresh = () => {
  window.location.href = '/#/'
}
</script>
